import React from 'react';
import { Link } from 'react-router-dom';
import '../Css_files/Topiclayout.css';

const TopicLayout = ({ 
  title, 
  icon, 
  color, 
  description, 
  topics, 
  resources, 
  careerPaths 
}) => {
  return (
    <div className="topic-page" style={{ '--theme-color': color }}>
      <header className="topic-header">
        <Link to="/" className="back-button">
          ← Back to Home
        </Link>
        <div className="topic-hero">
          <div className="topic-icon-large">
            {icon}
          </div>
          <h1 className="topic-title">{title}</h1>
          <p className="topic-description">{description}</p>
        </div>
      </header>

      <main className="topic-content">
        <section className="topics-section">
          <h2 className="section-title">Key Topics</h2>
          <div className="topics-grid">
            {topics.map((topic, index) => (
              <div key={index} className="topic-card">
                <h3 className="topic-card-title">{topic.title}</h3>
                <p className="topic-card-description">{topic.description}</p>
                <div className="topic-card-tags">
                  {topic.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className="topic-tag">{tag}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="resources-section">
          <h2 className="section-title">Learning Resources</h2>
          <div className="resources-grid">
            {resources.map((resource, index) => (
              <div key={index} className="resource-card">
                <div className="resource-icon">{resource.icon}</div>
                <h3 className="resource-title">{resource.title}</h3>
                <p className="resource-description">{resource.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="careers-section">
          <h2 className="section-title">Career Paths</h2>
          <div className="careers-grid">
            {careerPaths.map((career, index) => (
              <div key={index} className="career-card">
                <h3 className="career-title">{career.title}</h3>
                <p className="career-description">{career.description}</p>
                <div className="career-skills">
                  <strong>Key Skills:</strong>
                  <ul>
                    {career.skills.map((skill, skillIndex) => (
                      <li key={skillIndex}>{skill}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
};

export default TopicLayout;